import { BBSpinner, type BBSpinnerSize } from '../BBSpinner/BBSpinner';
import Flex from '../Flex/Flex';

export interface CircularLoadingProps {
  error?: boolean;
  size?: BBSpinnerSize;
}

export const CircularLoading = ({ error = false, size = 'md' }: CircularLoadingProps) => (
  <Flex
    sx={{
      height: '100vh',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1,
    }}
  >
    {error ? (
      <Flex.V sx={{ justifyContent: 'center', alignItems: 'center', gap: 2 }}>
        <h2 style={{ fontSize: '3rem', fontWeight: 300, margin: 0 }}>Error loading page</h2>
      </Flex.V>
    ) : (
      <BBSpinner size={size} />
    )}
  </Flex>
);
